import { render, staticRenderFns } from "./PedigreeChart.vue?vue&type=template&id=2acf1a82&scoped=true&"
import script from "./PedigreeChart.vue?vue&type=script&lang=js&"
export * from "./PedigreeChart.vue?vue&type=script&lang=js&"
import style0 from "./PedigreeChart.vue?vue&type=style&index=0&id=2acf1a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf1a82",
  null
  
)

export default component.exports